import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { Link, withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Button, Link as MaterialLink } from '@material-ui/core';
import Menu from './AdminMenu';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Amplify, { Auth } from 'aws-amplify';
import awsconfig from '../aws-exports';
import 'react-slidedown/lib/slidedown.css';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import HomeIcon from '@material-ui/icons/Home';
import jwt from 'jsonwebtoken';
import moment from 'moment-timezone';
import { tokenRefresh } from '../common/Constants';

Amplify.configure(awsconfig);

const styles = (theme) => ({
  header: {
    position: 'relative',
    marginBottom: '0px',
  },
  appBar: {
    position: 'relative',
    boxShadow: 'none',
  },
  toolBar: {
    width: '100%',
    height: '100%',
    '& .MuiTabs-root': {
      height: '100%',
    },
    '& .MuiTabs-scroller': {
      display: 'flex',
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: '0px',
    },
  },
  inline: {
    display: 'inline',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      paddingTop: '0.5em',
    },
  },
  logo: {
    padding: '20px',
    width: 'auto',
  },
  iconContainer: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  iconButton: {
    float: 'right',
  },
  tabContainer: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  tabs: {
    background: theme.palette.secondary.main,
  },
  tabItem: {
    textTransform: 'none',
    paddingTop: 20,
    paddingBottom: 20,
    minWidth: 200,
    minHeight: 60,
    fontSize: '1rem',
    color: '#ffffff',
    fontWeight: 'bold',
    [theme.breakpoints.down('md')]: {
      minWidth: 140,
    },
    '&$selected': {
      backgroundColor: '#004C9B',
      color: 'white',
    },
  },
  menus: {
    listStyle: 'none',
    '& li': {
      display: 'inline-block',
      marginLeft: '10px',
    },
  },
  drawer: {
    backgroundColor: 'rgba(28,30,59,.90)',
    color: '#adbecc',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  drawerMenus: {
    '& ul': {
      listStyle: 'none',
      padding: 0,
      minWidth: '200px',
      '& li': {
        cursor: 'pointer',
        lineHeight: '2.8em',
        fontSize: '1.1em',
        textAlign: 'center',
        '&:hover': {
          color: '#ffffff',
        },
      },
    },
  },
  breadcrumbs: {
    position: 'absolute',
    height: 60,
    backgroundColor: theme.palette.primary.main,
    top: 390,
    width: 1200,
    color: '#ffffff',
  },
  crumbs: {
    '&:first-child': {
      cursor: 'pointer',
    },
    '&:last-child': {
      cursor: 'pointer',
    },
    '&:not(:first-child)': {
      minWidth: 200,
    },
    borderRight: '1px solid #ffffff',
    '& .MuiPaper-root': {
      width: 200,
      maxWidth: 200,
      borderRadius: 0,
      marginTop: 14,
      marginLeft: 5,
      '& li': {
        fontSize: '0.9em',
      },
    },
  },
});

class AdminTopbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      menuDrawer: false,
      username: '',
      mainSocket: null,
      show: false,
      submenuOpen: false,
    };
    this.logout = this.logout.bind(this);
    this.showMenus = this.showMenus.bind(this);
    this.hideMenus = this.hideMenus.bind(this);
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  logout() {
    localStorage.clear();
    sessionStorage.clear();
    Auth.signOut().then(() => {
      this.props.history.push('/');
    });
  }

  componentDidMount() {
    try {
      if (sessionStorage.getItem('_in_user_')) {
        this.setState({
          username: sessionStorage.getItem('_in_user_').replace('innon_', ''),
        });
      } else {
        this.props.history.push('/login');
      }
    } catch (e) {
      console.error(e);
    }
    // check token expire
    const decoded = jwt.decode(sessionStorage.getItem('_in_jwt'));
    if (decoded) {
      console.log(
        'tokenExp',
        moment(decoded.exp * 1000)
          .tz('Asia/Seoul')
          .format('YYYY-MM-DD HH:mm:ss'),
      );
      const exp = moment(decoded.exp * 1000);
      const now = moment();
      const diff = exp.diff(now, 'minutes');
      console.log(`토근 만료까지 ${diff}분 남았습니다.`);
      if (diff < 10) tokenRefresh().then((r) => {});
    }

    window.scrollTo(0, 0);
  }

  componentWillUnmount() {}

  current = () => {
    return this.props.MIdx;
  };

  showMenus() {
    this.setState({ show: true });
  }
  hideMenus() {
    setTimeout(() => {
      this.setState({ show: false });
    }, 1000);
  }

  list = () => {
    return (
      <Grid container justify={'center'} spacing={0} className={this.props.classes.drawerMenus}>
        {Menu.map((item, index) => {
          return (
            <ul key={item.path}>
              {item.children.map((menu) => (
                <li key={menu.path}>{menu.label}</li>
              ))}
            </ul>
          );
        })}
      </Grid>
    );
  };

  logout() {
    localStorage.clear();
    sessionStorage.clear();
    Auth.signOut().then(() => {
      this.props.history.push('/');
    });
  }

  render() {
    const { classes, history } = this.props;

    return (
      <div className={classes.header}>
        <AppBar position="static" color="default" className={classes.appBar}>
          <Toolbar className={classes.toolBar}>
            <Grid container spacing={4} justify="center" alignItems={'center'}>
              <Grid item style={{ textAlign: 'center' }}>
                <Link to="/admin" className={classes.link}>
                  <img src="/images/innon_logo@2x.png" alt="" className={classes.logo} style={{ width: '50%' }} />
                </Link>
              </Grid>
            </Grid>
            <div
              style={{
                position: 'absolute',
                fontSize: '0.9em',
                fontWeight: 'bold',
                right: '150px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
              }}
            >
              <Grid container spacing={1} justify={'flex-end'}>
                <Grid item>접속계정: {this.state.username}</Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item>
                  <Button variant="outlined" color="primary" size="small" startIcon={<HomeIcon />} onClick={() => history.push('/')}>
                    Home
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="outlined" color="primary" size="small" startIcon={<ExitToAppIcon />} onClick={() => this.logout()}>
                    LOGOUT
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Toolbar>
          <Grid container spacing={4} justify="center">
            <Grid item xs={12}>
              <Tabs
                value={this.current() || this.state.value}
                indicatorColor="secondary"
                onChange={this.handleChange}
                centered
                className={classes.tabs}
                onMouseOver={this.showMenus}
                onMouseLeave={this.hideMenus}
              >
                {Menu.map((item, index) => (
                  <Tab
                    key={index}
                    component={item.external ? MaterialLink : Link}
                    href={item.external ? item.pathname : null}
                    to={
                      item.external
                        ? null
                        : {
                            pathname: item.pathname,
                            search: this.props.location.search,
                          }
                    }
                    classes={{ root: classes.tabItem }}
                    label={item.label}
                  />
                ))}
              </Tabs>
            </Grid>
          </Grid>
        </AppBar>
      </div>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(AdminTopbar));
